'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LegacyStorage = function () {
  function LegacyStorage(endpointUri) {
    _classCallCheck(this, LegacyStorage);

    this.onclose = function () {};

    this.uri = endpointUri;
    this.username = null;
    this.password = null;

    this.cache = {};
    this.models = [{ name: 'people' }, { name: 'relationships' }, { name: 'positions' }, { name: 'locations' }, { name: 'organisations' }, { name: 'logentries' }, { name: 'educations' }, { name: 'settings', volatile: true }];
  }

  _createClass(LegacyStorage, [{
    key: 'getAuthorizationValue',
    value: function getAuthorizationValue(password) {
      if (this.username && password) {
        return 'Basic ' + btoa(this.username + ':' + password);
      }

      if (this.username && this.password) {
        return 'Basic ' + btoa(this.username + ':' + this.password);
      }

      return '';
    }
  }, {
    key: 'open',
    value: function open(username, password) {
      var _this = this;

      if (username && password) {
        this.setCredentials(username, password);
      }

      return new Promise(function (resolve) {
        var modelCount = 0;
        _this.models.forEach(function (model) {
          _this.cache[model.name] = {};

          _this.getUncached(model).then(function (modelData) {
            window.PRIM.setMessage("Ophalen gegevens '" + model.name + "' (" + (modelCount + 1) + ' van ' + _this.models.length + ')...');

            modelData.forEach(function (modelItem) {
              _this.cache[model.name][modelItem.id] = modelItem;
            });

            modelCount++;

            if (modelCount === _this.models.length) {
              resolve();
            }
          });
        });
      });
    }
  }, {
    key: 'close',
    value: function close() {
      this.onclose();
    }
  }, {
    key: 'setCredentials',
    value: function setCredentials(newUsername, newPassword) {
      if (newUsername) {
        this.username = newUsername;
      }

      this.password = newPassword;
    }
  }, {
    key: 'status',
    value: function status(password) {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        var request = new XMLHttpRequest();

        request.onreadystatechange = function () {
          if (request.readyState === 4) {
            if (request.status === 200) {
              var contentType = request.getResponseHeader('Content-Type');
              if (contentType === 'application/json') {
                resolve(JSON.parse(request.responseText));
              } else {
                resolve('invalid');
              }
            } else if (request.status === 403) {
              resolve('invalid');
            } else if (request.status === 404) {
              var _contentType = request.getResponseHeader('Content-Type');
              if (_contentType === 'application/json') {
                resolve('invalid');
              } else {
                reject('offline');
              }
            } else {
              reject('offline');
            }
          }
        };

        var fullUri = _this2.uri + '/status';
        request.onerror = reject;
        request.open('GET', fullUri, true);
        request.setRequestHeader('Authorization', _this2.getAuthorizationValue(password));
        request.send();
      });
    }
  }, {
    key: 'get',
    value: function get(model, id) {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        if (model.uncached) {
          return _this3.getUncached(model, id);
        }

        if (_this3.cache[model.name]) {
          if (id && _this3.cache[model.name][id]) {
            resolve(_this3.cache[model.name][id]);
          } else {
            var values = [];

            for (var _key in _this3.cache[model.name]) {
              values.push(_this3.cache[model.name][_key]);
            }

            resolve(values);
          }
        } else {
          reject();
        }
      });
    }
  }, {
    key: 'getIndexes',
    value: function getIndexes(model) {
      var _this4 = this;

      return new Promise(function (resolve, reject) {
        if (_this4.cache[model.name]) {
          var indexes = {};
          var values = [];

          for (var id in _this4.cache[model.name]) {
            var value = _this4.cache[model.name][id][key];

            if (value && values.indexOf(value) === -1) {
              values.push(value);
            }
          }

          values.sort();

          resolve(values);
        } else {
          reject();
        }
      });
    }
  }, {
    key: 'changePassword',
    value: function changePassword(password) {
      var _this5 = this;

      return new Promise(function (resolve, reject) {
        var request = new XMLHttpRequest();

        request.onreadystatechange = function () {
          if (request.readyState === 4) {
            if (request.status === 200) {
              resolve();
            } else {
              reject();
            }
          }
        };

        var fullUri = _this5.uri + '/password';

        request.onerror = reject;
        request.open('POST', fullUri, true);
        request.setRequestHeader('Authorization', _this5.getAuthorizationValue());
        request.setRequestHeader('Content-Type', 'application/json');
        request.send(JSON.stringify({ password: password }));
      });
    }
  }, {
    key: 'getUncached',
    value: function getUncached(model, id) {
      var _this6 = this;

      return new Promise(function (resolve, reject) {
        if (model.volatile) {
          if (id) {
            resolve({});
          } else {
            resolve([]);
          }
          return;
        }

        var request = new XMLHttpRequest();

        request.onreadystatechange = function () {
          if (request.readyState === 4) {
            if (request.status === 200) {
              var data = JSON.parse(request.responseText);

              resolve(data);
            } else {
              reject();
            }
          }
        };

        var fullUri = _this6.uri + '/' + model.name + '/';

        if (id) {
          fullUri += id;
        }

        request.onerror = reject;
        request.open('GET', fullUri, true);
        request.setRequestHeader('Authorization', _this6.getAuthorizationValue());
        request.send();
      });
    }
  }, {
    key: 'put',
    value: function put(model, data) {
      var _this7 = this;

      window.PRIM.writeStatus();

      return new Promise(function (resolve, reject) {
        if (window.PRIM.License.isDemo) {
          window.PRIM.clearStatus();

          var newData = data;

          if (!newData.id) {
            newData.id = window.PRIM.getUUID();
          }

          _this7.cache[model.name][newData.id] = newData;
          resolve(newData);
          return;
        }

        var request = new XMLHttpRequest();

        request.onreadystatechange = function () {
          if (request.readyState === 4) {
            if (request.status === 200) {
              window.PRIM.clearStatus();

              var _newData = JSON.parse(request.responseText);

              _this7.cache[model.name][_newData.id] = _newData;
              resolve(_newData);
            } else {
              window.PRIM.writeFailedStatus();

              reject();
            }
          }
        };

        var fullUri = _this7.uri + '/' + model.name;

        if (data.id) {
          fullUri += '/' + data.id;
        } else {
          delete data.id;
        }

        request.onerror = reject;
        request.open(data.id ? 'PUT' : 'POST', fullUri, true);
        request.setRequestHeader('Authorization', _this7.getAuthorizationValue());
        request.setRequestHeader('Content-Type', 'application/json');
        request.send(JSON.stringify(data));
        data.id = null;
      }).catch(function (e) {
        window.PRIM.writeFailedStatus();
      });
    }
  }, {
    key: 'delete',
    value: function _delete(model, id) {
      var _this8 = this;

      return new Promise(function (resolve, reject) {
        if (window.PRIM.License.isDemo) {
          if (_this8.cache[model.name] && _this8.cache[model.name][id]) {
            delete _this8.cache[model.name][id];
          }

          resolve();
          return;
        }

        var request = new XMLHttpRequest();

        request.onreadystatechange = function () {
          if (request.readyState === 4) {
            if (request.status === 200) {
              if (_this8.cache[model.name] && _this8.cache[model.name][id]) {
                delete _this8.cache[model.name][id];
              }
              resolve();
            } else {
              reject();
            }
          }
        };

        var fullUri = _this8.uri + '/' + model.name + '/' + id;
        request.onerror = reject;
        request.open('DELETE', fullUri, true);
        request.setRequestHeader('Authorization', _this8.getAuthorizationValue());
        request.send();
      });
    }
  }, {
    key: 'checkInternet',
    value: function checkInternet() {
      var _this9 = this;

      return new Promise(function (resolve, reject) {
        var request = new XMLHttpRequest();

        request.onreadystatechange = function () {
          if (request.readyState === 4) {
            if (request.status === 200) {
              resolve('exists');
            } else if (request.status === 401) {
              resolve('invalid');
            } else if (request.status === 404) {
              resolve('new');
            } else {
              reject('offline');
            }
          }
        };

        request.onerror = reject;
        request.open('HEAD', _this9.uri, true);
        request.setRequestHeader('Authorization', _this9.getAuthorizationValue());
        request.send();
      });
    }
  }]);

  return LegacyStorage;
}();

exports.default = LegacyStorage;


//////////////////
// WEBPACK FOOTER
// ./js/lib/storage/LegacyStorage.js
// module id = 3
// module chunks = 0